import study from "../../assets/study.png";
import intern from "../../assets/intern.png";
import employe from "../../assets/employe.png";
import unemploye from "../../assets/unemployee.png";
import army from "../../assets/army.png";
import secondary_student from "../../assets/secondary_student.png"
export const talentStatus = {
  title: "Tell us more about yourself",
  description:
    "We will need some basic information about you before we get started",
  name: "What is your current status?",
  statuses: [
    {
      label: "Student",
      value: "studying",
      img: study,
      descriptions:
        "Currently studying and interested to explore mynext assessment and/or apply for internships via mynext",
    },
    {
      label: "School Student",
      value: "school_student",
      img: secondary_student,
      descriptions:
        "Currently studying in school and interested in using MyNext assessments to explore personal interests and strengths as part of early career planning.",
    },

    {
      label: "Intern",
      value: "internship",
      img: intern,
      descriptions:
        "Currently undergoing internship programme and interested to explore mynext assessment",
    },

    {
      label: "Employed",
      value: "employed",
      img: employe,
      descriptions:
        "Currently employed and interested to explore mynext assessment",
    },

    {
      label: "Unemployed",
      value: "unemployed",
      img: unemploye,
      descriptions:
        "Currently unemployed and looking for internship opportunity and interested to explore mynext assessment",
    },
    {
      label: "Armed Forces1",
      value: "army",
      img: army,
      descriptions: 
      "Currently an active member of the Malaysian Armed Forces, seeking new career opportunities and exploring the MyNext assessment."
    }
  ],
  err: "Please select a status.",
};
